var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 302,
    viewBox: "0 0 301 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2246 82.5629C45.3539 80.5975 45.3921 77.4988 47.3108 75.5801L66.1679 56.7229C68.0625 54.8284 71.1136 54.7639 73.0865 56.5767L271.105 238.525C273.199 240.45 273.268 243.732 271.257 245.743L239.678 277.322C237.692 279.308 234.458 279.268 232.521 277.233L47.2246 82.5629Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M213.563 59L243.969 89.4056L88.4056 244.969L58 214.564L213.563 59Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53554 126.16C-0.417079 124.207 -0.41708 121.041 1.53554 119.089L20.6274 99.9969C22.58 98.0443 25.7459 98.0443 27.6985 99.9969L61.6396 133.938C63.5922 135.891 63.5922 139.056 61.6396 141.009L42.5477 160.101C40.5951 162.054 37.4293 162.054 35.4767 160.101L1.53554 126.16Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2819 102.272C36.3293 100.32 36.3293 97.1539 38.2819 95.2012L91.3149 42.1682C93.2675 40.2156 96.4333 40.2156 98.386 42.1682L120.306 64.0885C122.259 66.0412 122.259 69.207 120.306 71.1596L67.2733 124.193C65.3206 126.145 62.1548 126.145 60.2022 124.193L38.2819 102.272Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5855 47.689L104.071 39.2037L124.577 59.7098L116.092 68.1951L95.5855 47.689Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3448 109.814L43.4115 98.7475L63.9176 119.254L52.8509 130.32L32.3448 109.814Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.118 20.2635C152.1 29.2455 151.942 43.9666 142.765 53.1439C133.588 62.3212 118.866 62.4795 109.884 53.4975C100.902 44.5154 101.061 29.7943 110.238 20.617C119.415 11.4397 134.136 11.2814 143.118 20.2635Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1226 294.45L101.714 238.859C110.708 247.853 111.778 261.367 104.102 269.042L76.3065 296.838C68.631 304.514 55.1172 303.444 46.1226 294.45Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1415 206.286L13.5502 261.877C4.55563 252.883 3.48633 239.369 11.1619 231.693L38.9575 203.898C46.6331 196.222 60.1469 197.292 69.1415 206.286Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.668 240.813L84.2112 260.27L47.7302 223.789L67.1871 204.332L103.668 240.813Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M260.877 8.28616L205.286 63.8774C196.292 54.8828 195.222 41.369 202.898 33.6934L230.693 5.89781C238.369 -1.77774 251.883 -0.708438 260.877 8.28616Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M237.859 96.4498L293.45 40.8585C302.444 49.8531 303.514 63.3669 295.838 71.0425L268.042 98.8381C260.367 106.514 246.853 105.444 237.859 96.4498Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M203.332 61.9231L222.789 42.4661L259.27 78.9472L239.813 98.4041L203.332 61.9231Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderConstruction);
export default __webpack_public_path__ + "static/media/UnderConstruction.21734f3779b10060ad52c4e7e42747d6.svg";
export { ForwardRef as ReactComponent };